import { History } from "lucide-react";
import { useShop } from "../context/ShopContext";
import ProductCarousel from "./ProductCarousel";

export default function RecentlyViewed({ excludeId = null }) {
  const { recentlyViewed } = useShop();
  const items = recentlyViewed.filter((p) => p.id !== excludeId);
  if (!items.length) return null;
  return (
    <section className="mt-24 lg:mt-32" data-testid="recently-viewed">
      <div className="flex items-center gap-4 mb-10">
        <History className="w-4 h-4 text-gold" />
        <h2 className="font-serif text-3xl text-ivory font-light">Recently Viewed</h2>
      </div>
      <ProductCarousel products={items} testid="recently-viewed-carousel" />
    </section>
  );
}
